// extracted by mini-css-extract-plugin
export default {"SearchBarInput":"SearchBar_SearchBarInput__-OPmJ"};